
import { Vue } from 'vue-class-component'

export default class PlacesTitle extends Vue {

}
